import editSrc from '@corbado/shared-ui/assets/edit.svg';
import React, { useRef } from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const EditIcon = ({ color, ...props }) => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, editSrc, color === 'secondary' ? '--cb-text-secondary-color' : '--cb-text-primary-color');
    return (React.createElement(Icon, { src: logoSVG, alt: 'edit-icon', ref: svgRef, ...props }));
};
